export enum TopicStatusEnum {
    Active = 1,
    Completed = 2,
    Cancelled = 3
}